<template>
    <div  ref="otpModalRef" class="modal-overlay hidden" :class="{ 'dark-theme': isDark }" @click.self="closeModal">
        <div class="modal-container otp-modal">
          <div class="modal-body">
            <h5 class="modal-title">{{ $t('otp.title') }}</h5>
            <p class="modal-text">{{ $t('otp.description') }} {{ msisdn }}</p>
            
            <div class="otp-input-fields">
              <input
                v-for="(digit, index) in otpDigits"
                :key="index"
                v-model="otpDigits[index]"
                type="tel"
                maxlength="1"
                class="otp-input"
                @input="handleInput($event, index)"
                @keydown="handleKeydown($event, index)"
                :ref="el => otpInputRefs[index] = el"
              />
            </div>

            <a href="#" class="resend-link" @click.prevent="resendOtp">{{ $t('otp.resendCode') }}</a>
          </div>
          <button class="btn btn-confirm" @mousedown.prevent="confirmOtp" @touchstart.prevent="confirmOtp">{{ $t('profile.modal.confirm') }}</button>
        </div>
      </div>
</template>
<script setup>
import { defineEmits, defineProps, ref } from "vue";
const props = defineProps({
  id: String,
  msisdn: String,
  isDark: Boolean,
});
const otpInputRefs = ref([]);
const otpDigits = ref(['', '', '', '']);
const otpModalRef = ref(null)
const emit = defineEmits(["confirmOtp","resendOtp"]);

const handleInput = (event, index) => {
  const value = event.target.value;
  // Ensure we only take the last character if multiple are entered
  const char = value.slice(-1);
  
  if (char >= '0' && char <= '9') {
    otpDigits.value[index] = char;
    if (index < otpInputRefs.value.length - 1) {
      otpInputRefs.value[index + 1]?.focus({ preventScroll: true });
    }
  } else {
    otpDigits.value[index] = '';
  }
}

const handleKeydown = (event, index) => {
  if (event.key === 'Backspace' && !otpDigits.value[index] && index > 0) {
    otpInputRefs.value[index - 1]?.focus({ preventScroll: true });
  }
}

let isConfirming = false;
const confirmOtp = () => {
  if (isConfirming) return;
  isConfirming = true;
  emit("confirmOtp", otpDigits.value.join(''));
  setTimeout(() => { isConfirming = false; }, 1000);
};

const showModal = () => {
  isConfirming = false;
  otpModalRef.value?.classList.remove('hidden')
}
const closeModal = () => {
  otpDigits.value = ['', '', '', ''];
  otpModalRef.value?.classList.add('hidden')
};


const resendOtp = () => {
  emit("resendOtp");
};

defineExpose({
  showModal,
  closeModal
})

</script>
<style>
/* 🚀 التعديل: لضمان بقاء لون النص أبيض وتغيير الخلفية عند مرور الفأرة على زر التأكيد */
.btn-confirm:hover {
  background-color: #e04a2a; /* درجة أغمق من البرتقالي */
  color: white !important; /* التأكيد على بقاء لون النص أبيض */
}

/* Dark Mode - OTP Modal */
.dark-theme.modal-overlay .modal-container,
.dark-theme .modal-container {
  background-color: #1E1E1E;
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-title,
.dark-theme .modal-title {
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-text,
.dark-theme .modal-text {
  color: #a0a0a0;
}
.dark-theme.modal-overlay .otp-input,
.dark-theme .otp-input {
  color: #ffffff;
  border-bottom-color: #444;
}
</style>